import React, { useEffect, useReducer, useState } from 'react'
import { Button } from '@/Components/ui/button'
import Datatable from '@/Components/Common/Datatable'
import UserColumns from './UserColumns'
import { Input } from '@/Components/ui/input'
import { Link, useLocation } from 'react-router-dom'
import ClientService from '@/Service/ClientService'
import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/Components/ui/dropdown-menu'
import DataTableEnumType from '@/Enums/DataTableTypeEnum'
import HeaderCard from '@/Components/HeaderCard'
import { SquarePlus } from 'lucide-react'
import BodyCard from '@/Components/BodyCard'
import { checkPermission } from '@/utils/helper'
import RequiredPermission from '@/assets/data/RequiredPermission'
import { useAuth } from '@/Context/AuthContext'
import UserService from '@/Service/UserService'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import ConfirmationPopup from '@/Components/Common/ConfirmationPopup'

const UserListing = () => {
    const { userInfo } = useAuth()

    

    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        totaluserCount: 0,
        isDataFetching: false,
        deleteConfirmationOpen: false,
        users: [],
        deleteId: [],
        allcheck: false,
        emailSearch: '',
        nameSearch: '',
        isOpen: false,
        queryParam: {
            page: 1,
            email: '',
            username: '',
            name: '',
        },
    })

    const [debouncedUsername] = useDebounce(event.nameSearch, Constant.DEBOUNCE_DELAY)
    const [debouncedName] = useDebounce(event.nameSearch, Constant.DEBOUNCE_DELAY)
    const [debouncedEmail] = useDebounce(event.emailSearch, Constant.DEBOUNCE_DELAY)

    const location = useLocation()
    const getUser = async (page = 1) => {
        console.log('in getuser')
        updateEvent({ isDataFetching: true, users: [] })
        try {
            const resp = await UserService.getUsers(event.queryParam)
            if (resp.data.success) {
                console.log('response data', resp.data.data)
                updateEvent({ users: resp.data.data, totaluserCount: resp.data.pagination.total_record })
            }
        } catch (err) {
            console.log('err', err)
        }
        updateEvent({ isDataFetching: false })
    }
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
        // setQueryParam((prev) => {
        //     return {
        //         ...prev,
        //         page: page,
        //     }
        // })
    }, [location.search])

    useEffect(() => {
        updateEvent({
            queryParam: {
                page: 1,
                username: debouncedUsername,
                email: debouncedEmail,
                name: debouncedName,
            },
        })
        // setQueryParam((prev) => {
        //     const newSearchParams = new URLSearchParams(window.location.search)
        //     newSearchParams.delete('page')
        //     const newUrl = `${window.location.pathname}?${newSearchParams.toString()}`
        //     window.history.replaceState({}, '', newUrl)
        //     return {

        //     }
        // })
    }, [debouncedUsername, debouncedName, debouncedEmail])

    useEffect(() => {
        getUser()
    }, [event.queryParam.page, event.queryParam.name, event.queryParam.username, event.queryParam.email])

    const deleteUsers = async (action) => {
        if (!action) {
            updateEvent({ deleteConfirmationOpen: false })
            return false
        }
        try {
            const resp = await UserService.deleteUsers(event.deleteId)
            if (resp.data.success) {
                getUser()
            }
            updateEvent({ deleteId: [], allcheck: false })
        } catch (err) {
            console.log('error', err)
        }
        updateEvent({ deleteConfirmationOpen: false })
    }

    return (
        <>
            <HeaderCard>
                <div className="flex justify-between items-center">
                    {checkPermission(RequiredPermission.USER.CREATE, userInfo.roles) && (
                        <Link to="/user/new">
                            <Button className="bg-primary-btn hover:bg-primary-purpal">
                                <SquarePlus />
                                Add User
                            </Button>
                        </Link>
                    )}

                    {checkPermission(RequiredPermission.USER.DELETE, userInfo.roles) && (
                        <Button
                            variant="outline"
                            onClick={() => updateEvent({ deleteConfirmationOpen: true })}
                            className={`ml-[10px] ${event.deleteId.length > 0 ? 'block' : 'hidden'}`}
                        >
                            Delete
                        </Button>
                        // <DropdownMenu className="ml-[10px] ">
                        //     <DropdownMenuTrigger asChild>
                        //         <Button variant="outline" className={`ml-[10px] ${deleteId.length > 0 ? 'block' : 'hidden'}`}>
                        //             Action
                        //         </Button>
                        //     </DropdownMenuTrigger>
                        //     <DropdownMenuContent>
                        //         <DropdownMenuItem onClick={deleteClients}>Delete</DropdownMenuItem>
                        //     </DropdownMenuContent>
                        // </DropdownMenu>
                    )}
                </div>
            </HeaderCard>
            <ConfirmationPopup
                open={event.deleteConfirmationOpen}
                message="Are you sure you want to delete this permanently?"
                type={DeleteConfirmationTypeEnum.DELETE}
                setOpen={() => updateEvent({ deleteConfirmationOpen: !event.deleteConfirmationOpen })}
                handleAction={deleteUsers}
            />
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    {/* <Input type="text" name="notForDisable" onChange={(e) => setSearchUsername(e.target.value)} placeholder="Username" /> */}
                    <Input type="text" name="useremail" onChange={(e) => updateEvent({ emailSearch: e.target.value })} placeholder="Email" />
                    <Input type="text" name="username" onChange={(e) => updateEvent({ nameSearch: e.target.value })} placeholder="Name" />
                </div>
                <Datatable
                    columns={UserColumns()}
                    data={event.users}
                    totalDataCount={event.totaluserCount}
                    allcheck={event.allcheck}
                    deleteId={event.deleteId}
                    type={DataTableEnumType.USER}
                    loading={event.isDataFetching}
                    updateEvent={updateEvent}
                />
            </BodyCard>
        </>
    )
}

export default UserListing
